import {Component, Input} from '@angular/core';

@Component({
  selector: 'app-date',
  templateUrl: './date.component.html',
  styleUrls: ['./date.component.scss']
})
export class DateComponent {
  @Input() inputStyle: string; // 'default' or 'rounded'
  @Input() inputSize: string; // 'form-control-lg', 'form-control-sm', or empty for default size
  @Input() inputType: string; // 'date', 'time', or 'datetime-local'
  @Input() minDate: string; // Optional min date value
  @Input() maxDate: string; // Optional max date value
}
